import http from './base/http';

// 登录
export function login(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10000',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// 注销
export function logout(data) {
  const params = { // http请求的参数
    SERVICE_ID: '10000',
    OTYPE: 2,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 修改密码
export function editPass(data) {
  const params = {
    SERVICE_ID: '10000',
    OTYPE: 3,
    USER_ID: sessionStorage.getItem('userId'),
    SESSION: sessionStorage.getItem('session'),
    ...data,
  };
  return http.post(params);
}
// 获取手机验证码
export function phoneCode(data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}
// 重置密码
export function forget(data) {
  const params = {
    SERVICE_ID: '10000',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/api/Login.js